import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { sizes } from '../../styles/utils';
import { bind } from '../utils';
import { useConfigContext } from '../config';
var typeDefs = {
  size: sizes,
  counts: [Number, String],
  total: Number,
  value: Number,
  limit: Number,
  limits: Array,
  flat: Boolean,
  simple: Boolean,
  showTotal: Boolean,
  showGoto: Boolean,
  showLimits: Boolean,
  disableBtn: Function,
  disablePage: Function
};
var defaults = function defaults() {
  return {
    size: 'default',
    counts: 7,
    total: 0,
    value: 1,
    limit: 10,
    limits: [10, 20, 50],
    showTotal: true,
    showLimits: true
  };
};
var events = {
  change: true
};
export var Pagination = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Pagination, _Component);
  function Pagination() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.ignore = false;
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Pagination.prototype;
  _proto.init = function init() {
    var _this2 = this;
    // avoid setting incorrect value
    this.changePage(this.get('value'));
    this.watch('limit', function (v) {
      var oldvalue = _this2.get('value');
      if (oldvalue !== 1) {
        // we should not silent it, but let it trigger change event
        // to sync the value to parent
        // set a flag to indicate that this set will be ignored to trigger
        // change event again in bellow $change:value callback
        // #341
        _this2.ignore = true;
        _this2.set('value', 1);
        _this2.ignore = false;
      }
      _this2.trigger('change', {
        limit: v,
        value: 1
      });
    }, {
      inited: true
    });
    this.watch('value', function (v) {
      if (_this2.ignore) return;
      _this2.trigger('change', {
        limit: _this2.get('limit'),
        value: v
      });
    }, {
      inited: true
    });
  };
  _proto.changePage = function changePage(page) {
    var _this$get = this.get(),
      total = _this$get.total,
      limit = _this$get.limit;
    var totalPages = Math.ceil(total / limit);
    if (page > totalPages) {
      page = totalPages;
    }
    // perhaps totalPages is 0
    if (page < 1) {
      page = 1;
    }
    if (this.get('value') !== page) {
      this.set('value', page);
    }
  };
  _proto.prev = function prev() {
    this.changePage(this.get('value') - 1);
  };
  _proto.next = function next() {
    this.changePage(this.get('value') + 1);
  };
  _proto.fastPrev = function fastPrev() {
    var _this$get2 = this.get(),
      value = _this$get2.value,
      counts = _this$get2.counts;
    var page = value - Math.ceil(Number(counts) / 2);
    this.changePage(page);
  };
  _proto.fastNext = function fastNext() {
    var _this$get3 = this.get(),
      value = _this$get3.value,
      counts = _this$get3.counts;
    var page = value + Math.ceil(Number(counts) / 2);
    this.changePage(page);
  };
  _proto.goto = function goto(e) {
    var _this$get4 = this.get(),
      disablePage = _this$get4.disablePage,
      limit = _this$get4.limit;
    var value = parseInt(e.target.value) || 1;
    if (disablePage && disablePage(value, limit)) {
      return;
    }
    this.changePage(value);
  };
  return Pagination;
}(Component);
Pagination.template = template;
Pagination.typeDefs = typeDefs;
Pagination.defaults = defaults;
Pagination.events = events;
__decorate([bind], Pagination.prototype, "changePage", null);
__decorate([bind], Pagination.prototype, "prev", null);
__decorate([bind], Pagination.prototype, "next", null);
__decorate([bind], Pagination.prototype, "fastPrev", null);
__decorate([bind], Pagination.prototype, "fastNext", null);
__decorate([bind], Pagination.prototype, "goto", null);